import axios from "axios";
import {apiUri} from "../../config";
import {push} from "connected-react-router";
//import { NotificationManager } from 'react-notifications';

export const FETCH_PUBLICATIONS_ATTEMPT = 'FETCH_PUBLICATIONS_ATTEMPT';
export const FETCH_PUBLICATIONS_SUCCESS = 'FETCH_PUBLICATIONS_SUCCESS';
export const FETCH_PUBLICATIONS_FAILURE = 'FETCH_PUBLICATIONS_FAILURE';
/*
export const CREATE_PUBLICATIONS_ATTEMPT = 'CREATE_PUBLICATIONS_ATTEMPT';
export const CREATE_PUBLICATIONS_SUCCESS = 'CREATE_PUBLICATIONS_SUCCESS';
export const CREATE_PUBLICATIONS_FAILURE = 'CREATE_PUBLICATIONS_FAILURE';
*/
export const FETCH_PUBLICATION_ATTEMPT = 'FETCH_PUBLICATION_ATTEMPT';
export const FETCH_PUBLICATION_SUCCESS = 'FETCH_PUBLICATION_SUCCESS';
export const FETCH_PUBLICATION_FAILURE = 'FETCH_PUBLICATION_FAILURE';

export const SELECT_PUBLICATION = 'SELECT_PUBLICATION';

export const PUBLICATION_UPDATE = 'PUBLICATION_UPDATE';

global.loader = false;

export const fetch_publications = (page) => {
    return (dispatch) => {
    	console.log('fetch_publications');

        dispatch({type: FETCH_PUBLICATIONS_ATTEMPT, page: page});
        axios.get(apiUri + "/publication?page=" + page)
            .then(json => {
                const response = json.data;
                dispatch({
                    type: FETCH_PUBLICATIONS_SUCCESS,
                    data: response.content,
                    page: page,
                    total_pages: response.totalPages
                })
            })
            .catch(err => {
                dispatch({type: FETCH_PUBLICATIONS_FAILURE, error: err})
            })
    }
};

export const select_publication = (publication_id) => {
    return (dispatch) => {
        dispatch({type: SELECT_PUBLICATION, id: publication_id});
        dispatch(push("/publication/" + publication_id));
    }
};

export const fetch_publication = (publication_id) => {
    return (dispatch) => {
        dispatch({type: FETCH_PUBLICATION_ATTEMPT, id: publication_id});
        axios.get(apiUri + "/publication/" + publication_id)
            .then(json => {
                dispatch({type: FETCH_PUBLICATION_SUCCESS, id: publication_id, data: json.data})
            })
            .catch(err => {
                dispatch({type: FETCH_PUBLICATION_FAILURE, id: publication_id, error: err})
            })
    }
};
/*
export const updatePurchaseType = (id , Usertype,Type) => {
    var urlType = apiUri + "/publication/"+id;
    if(Type==='CUSTOM'){
        urlType = urlType+"_"+Type;      
    }
     return (dispatch) => {
       
        axios.put(urlType,'')
        .then(json => {
            global.loader = false;
            NotificationManager.success("Event Study Saved Successfully");
           dispatch(push("/publications"));

        })
        .catch(err => {
            console.log("Failed to create publication " + err);
            global.loader = false;
            NotificationManager.error("Failed to create publication" + err);
            dispatch({type: CREATE_PUBLICATIONS_FAILURE, error: err.response.data.message})
        })
     }
};

export const create_publication = (data,isSubscribe) => {
   
    //const pathname = window.location.pathname;
    
     return (dispatch) => {
       
        dispatch({type: CREATE_PUBLICATIONS_ATTEMPT});
        axios.post(apiUri + "/publication",data)
            .then(json => {
                dispatch({type: CREATE_PUBLICATIONS_SUCCESS, data: json});
                //dispatch(updatePurchaseType(json.data.data.id , isSubscribe ? 'SUBSCRIBER' : 'NONSUBSCRIBER',pathname.includes("/publications/create")&&'CUSTOM'))
            	global.loader = false;
	            NotificationManager.success("Event Study Saved Successfully");
	        	dispatch(push("/publications"));
            })
            .catch(err => {     
                console.log("Failed to create publication----> " + err);
                global.loader = false;
                NotificationManager.error("Failed to create publication" + err);
                dispatch({type: CREATE_PUBLICATIONS_FAILURE, error: err.response.data.message})
            })
     }
};


export const publicationUpdate = UpdatePublicationId => {
    return dispatch => {
            axios.get(apiUri + "/publication/"+ UpdatePublicationId)
            .then(json => {
                dispatch({type: PUBLICATION_UPDATE, 
                    UpdatePublicationResult: json.data})
            })
            .catch(err => {
                console.log("Failed to create risk assessment " + err);
                dispatch({type: CREATE_PUBLICATIONS_FAILURE, error: err.response.data.message})
            })
    };
};
*/


// WEBPACK FOOTER //
// ./src/publications/redux/actions.js